import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseOrderDirectionEnum, BaseOrderKeyEnum } from 'base';

@Component({
  selector: 'base-customer-external-employees-list-headline',
  templateUrl: './base-customer-external-employee-list-headline.component.html',
})
export class BaseCustomerExternalEmployeeListHeadlineComponent {
  @Input() allSelected = false;
  @Input() isListEmpty = false;
  @Input() orderKey: BaseOrderKeyEnum;
  @Input() orderDirection: BaseOrderDirectionEnum;
  @Input({ required: true }) isWorkCouncil: boolean;
  @Output() selectAll = new EventEmitter<boolean>();
  @Output() changeOrder = new EventEmitter<{
    direction: BaseOrderDirectionEnum;
    key: BaseOrderKeyEnum;
  }>();

  orderKeys = BaseOrderKeyEnum;

  onAllSelected(isChecked: boolean): void {
    this.selectAll.emit(isChecked);
  }
}
